import React, { useEffect, useState } from 'react';
import { Link } from "react-router-dom";

const AboutLeftTab = () => {


    useEffect(() => {
        window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
    }, []);

    return (
        <div className="col-lg-4 pe-lg-4 order-xl-1 order-lg-1 order-md-1 order-sm-2 order-2">
            <div className="additional-information">
                <div className="list">
                    <ul>
                        <li className='text-dark'>
                            <Link to="/about/about-college">
                                <i className="fas fa-university"></i> About College
                            </Link>
                        </li>
                        <li className='text-dark'>
                            <Link to="/about/management">
                                <i className="fas fa-users-cog"></i> Management
                            </Link>
                        </li>
                        <li className='text-dark'>
                            <Link to="/about/recognitions">
                                <i className="fas fa-award"></i>
                                Approvals and Accreditations
                            </Link>
                        </li>
                        <li className='text-dark'>
                            <Link to="/about/iso-certificate">
                                <i className="fas fa-file-alt"></i>
                                ISO Certificate
                            </Link>
                        </li>

                        <li className='text-dark'>
                            <Link to="/about/aicte">
                                <i className="fas fa-file-alt"></i> AICTE Approval
                            </Link>
                        </li>
                        <li className='text-dark'>
                            <Link to="/about/jntuh-approval">
                                <i className="fas fa-file-alt"></i> JNTUH Approval Letters
                            </Link>
                        </li>
                        <li className='text-dark'>
                            <Link to="/about/governing-body">
                                <i className="fas fa-users"></i> Governing Body
                            </Link>
                        </li>
                        <li className='text-dark'>
                            <Link to="/about/policy">
                                <i className="fas fa-file-alt"></i> Policy
                            </Link>
                        </li>
                        <li className='text-dark'>
                            <Link to="/about/academic-council">
                                <i className="fas fa-users"></i> Academic Council
                            </Link>
                        </li>
                        <li className='text-dark'>
                            <Link to="/about/adviser">
                                <i className="fas fa-user-tie"></i> Advisor
                            </Link>
                        </li>
                        <li className='text-dark'>
                            <Link to="/about/principal">
                                <i className="fas fa-chalkboard-teacher"></i> Principal
                            </Link>
                        </li>
                        <li className='text-dark'>
                            <Link to="/about/dean-academics">
                                <i className="fas fa-user-graduate"></i> Dean Academics
                            </Link>
                        </li>
                        <li className='text-dark'>
                            <Link to="/about/dean-admissions">
                                <i className="fas fa-user-check"></i> Dean Admissions
                            </Link>
                        </li>
                        {/* <li className='text-dark'>
                            <Link to="/about/board-of-studies">
                                <i className="fas fa-book-open"></i> Board of Studies (BoS)
                            </Link>
                        </li> */}
                        <li className='text-dark'>
                            <Link to="/about/committee">
                                <i className="fas fa-sitemap"></i> College Committees
                            </Link>
                        </li>
                        <li className='text-dark'>
                            <Link to="/about/admissions">
                                <i className="fas fa-user-plus"></i> Admissions
                            </Link>
                        </li>
                        <li className='text-dark'>
                            <Link to="/about/mandatory-disclosure">
                                <i className="fas fa-file-invoice"></i> Mandatory Disclosure
                            </Link>
                        </li>
                        <li className='text-dark'>
                            <Link to="/audit-reports">
                                <i className="fas fa-clipboard-check"></i> Audit Reports
                            </Link>
                        </li>
                        <li className='text-dark'>
                            <Link to="/about/service-rules">
                                <i className="fas fa-file-contract"></i> Service Rules
                            </Link>
                        </li>
                        <li className='text-dark'>
                            <Link to="/about/organogram">
                                <i className="fas fa-network-wired"></i> Organogram
                            </Link>
                        </li>
                        <li className='text-dark'>
                            <Link to="/about/salient-features">
                                <i className="fas fa-star"></i> Salient Features
                            </Link>
                        </li>

                    </ul>

                </div>
            </div>
        </div>
    );
};

export default AboutLeftTab;
